module.exports = __webpack_public_path__ + "img/part-1-title.dd8356bd.png";